import { render } from "./GetParticipantsListSendEmail.vue?vue&type=template&id=40b876dd"
import script from "./GetParticipantsListSendEmail.vue?vue&type=script&lang=js"
export * from "./GetParticipantsListSendEmail.vue?vue&type=script&lang=js"

import "./GetParticipantsListSendEmail.vue?vue&type=style&index=0&id=40b876dd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__